module.exports = __webpack_public_path__ + "img/logo.64f280a8.webp";